// Copyright (c) 2017 Deere & Company

import AuditStatusTcsm from './audit-status-tcsm';
import t from 'tcomb';

const DivisionSummary = t.struct({
    divisionCompl24Months: t.maybe(t.Number),
    divisionDue3Months: t.maybe(t.Number),
    divisionOverdue: t.maybe(t.Number),
    tcsm: t.list(AuditStatusTcsm, 'tcsm')
}, {
    name: 'DivisionSummary',
    strict: true
});

export const getDefaultState = () => new DivisionSummary({
    divisionCompl24Months: null,
    divisionDue3Months: null,
    divisionOverdue: null,
    tcsm: []
});

export default DivisionSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/division-summary.js